const style = (theme) => {
  const output = {
    root: {
      color: theme.colors[0],
    },
    page: {
      '& > *:not(:first-child)': {
        marginTop: 150,
      },
      '& > *:last-child': {
        marginBottom: 150,
      },
    },
    wrapper: {
      extend: theme.smallWrapper,
    },
    backgroundLight: {
      background: theme.colors[6],
      '& > *': {
        paddingBottom: 150,
      },
    },
    singleImageWrapper: {
      position: 'relative',
      zIndex: 1,
      '&::before': {
        content: '""',
        display: 'block',
        background: theme.colors[9],
        position: 'absolute',
        zIndex: 1,
        bottom: '50%',
        left: 0,
        width: '100%',
        height: '51%',
      },
    },
    singleImage: {
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      paddingBottom: '55%',
    },
    titleContainer: {
      marginTop: 70,
      '& h2': {
        fontFamily: theme.fonts[1],
        fontSize: '5.2vw',
        color: theme.colors[4],
        fontWeight: 100,
        lineHeight: 1,
      },
    },
    textContainer: {
      marginTop: 70,
      '& p': {
        fontSize: 16,
        color: theme.colors[4],
        columns: 'auto 2',
        columnGap: 80,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    page: {
      '& > *:not(:first-child)': {
        marginTop: 80,
      },
      '& > *:last-child': {
        marginBottom: 80,
      },
    },
    titleContainer: {
      '& h2': {
        fontSize: 65,
      },
    },
    textContainer: {
      '& p': {
        columns: 1,
        columnGap: 0,
      },
    },
    backgroundLight: {
      '& > *': {
        paddingBottom: 50,
      },
    },
  }

  return output
}

export default style
